export default __webpack_public_path__ + "static/media/White0004.eaff4221.png";